import { DetailsPageTopControlsView } from "../common/panels/misc/DetailsPageTopControlsView/DetailsPageTopControlsView";
import Detail from "../common/panels/Detail/Detail";
import { Table } from "../common/panels/Detail/DetailTable";
import { useFeatureFlag } from "../common/contexts/UseFeatureFlags";
import { NotSet } from "../common/misc/UIconstants";
import { EntityDetailProps, EntityDetailTableProps } from "../common/entity/EntityInterfaces";
import { GetProjects } from "../common/misc/EntityRenders/EntityRenderer";
import { CustomTypeDetailRow, CustomTypeRenderer } from "../Customization/CustomTypes/generics/CustomTypeRenderer";
import { CustomFieldReferencesTile } from "../common/sidebar/tiles/CustomFieldReferencesTile";
import { EntityRestoreButton } from "../common/entity/entityComponents/EntityRestoreButton";
import { EntitySidebarTileAutosorter } from "../common/sidebar/tiles/EntitySidebarTile/EntitySidebarTileAutosorter";
import { EntityDeleteButton } from "../Entities/GenericComponents/common/GenericEntityDetailPage";
import { EntityEditButton } from "../common/entity/entityComponents/EntityEditButton";
import { EntityCloneButton } from "../common/entity/entityComponents/EntityCloneButton";
import { EntityComplianceDropdown } from "../common/entity/entityComponents/EntityComplianceDropdown";
import { GenericEntityExportButton } from "../Entities/GenericComponents/common/GenericEntityExportButton";

export const SampleDetailTable = ({
  entity,
  entityTypeId,
  entityConstants,
  fieldLabels,
  showLinks = true,
}: EntityDetailTableProps<"samples">) => {
  return (
    <>
      <Table noPadding nonFoldable>
        <Table.Head>Details</Table.Head>
        <Table.Body>
          <Table.Body.RowContent
            title={fieldLabels.name}
            content={
              <div className={"container_label"}>
                <div className={"container_label_name"} style={{ fontWeight: 600 }}>
                  {entity.name ?? NotSet}
                </div>
                <div className={"container_label_id"}>
                  <span style={{ whiteSpace: "nowrap" }}>Sample-ID: {entity.id}</span>
                </div>
              </div>
            }
          />

          <CustomTypeDetailRow entity={entity} entityTypeId={entityTypeId} showLinks={showLinks} />

          <Table.Body.RowContent
            title={fieldLabels.projects}
            content={<GetProjects projects={entity.projects} createLinks={showLinks} />}
          />
        </Table.Body>
      </Table>
      <CustomTypeRenderer entity={entity} showLinks={showLinks} />
    </>
  );
};

export const SampleDetail = ({
  permissions,
  routes,
  entity,
  entityApi,
  entityConstants,
  fieldLabels,
  entityTypeId,
}: EntityDetailProps<"samples">) => {
  const isElnActive = useFeatureFlag("eln");

  return (
    <Detail
      head={
        <DetailsPageTopControlsView
          entityTypeId={entityTypeId}
          entity={entity}
          entityConstants={entityConstants}
          controls={
            <>
              <EntityEditButton
                entity={entity}
                entityConstants={entityConstants}
                permissions={permissions}
                routes={routes}
              />
              <EntityRestoreButton
                entity={entity}
                entityConstants={entityConstants}
                entityApi={entityApi}
                permissions={permissions}
              />
            </>
          }
          controlsDropdown={
            <>
              <li>
                <EntityCloneButton
                  entity={entity}
                  entityConstants={entityConstants}
                  routes={routes}
                  permissions={permissions}
                />
              </li>
              <li>
                <GenericEntityExportButton entity={entity} entityTypeId={entityTypeId} />
              </li>
              <EntityComplianceDropdown entity={entity} entityTypeId={entityTypeId} showSignButton />
              <li className="divider" />
              <li>
                <EntityDeleteButton entity={entity} entityTypeId={entityTypeId} />
              </li>
            </>
          }
        />
      }
      mainStyle={{ padding: "0px 10px" }}
      main={
        <div className="flex col-nowrap" id="sample-detail-table">
          <SampleDetailTable
            entity={entity}
            entityConstants={entityConstants}
            fieldLabels={fieldLabels}
            entityTypeId={entityTypeId}
          />
        </div>
      }
      sidebar={
        <EntitySidebarTileAutosorter>
          {/* {isElnActive && !!sample.relations.labNotebookEntries?.count && (
                <LabNotebookEntriesTile
                  title="Notebook mentions"
                  defaultFilters={{ sampleIds: [sample.id] }}
                  excludeFilters={{ sampleIds: () => false }}
                />
              )} */}

          <CustomFieldReferencesTile
            entityType="Sample"
            entity={entity}
            labNotebookEntryFilters={isElnActive ? { sampleReferenceIds: [entity.id] } : undefined}
          />
          {/* <AttachmentsTileWrapped entity={sample} /> */}
          {/* <SamplesTile title="Related Samples" defaultFilters={{ excludeIds: [sample.id] }} /> */}
        </EntitySidebarTileAutosorter>
      }
    />
  );
};
